<template>
<div class="news-datails" ref="newsDetContainer">
  <div>
    <Header></Header>
    <div class="content">
      <div class="content-header">
        <h3 >{{newsData.name}}</h3>
        <div class="newsinfo">
          <span class="time">{{newsData.time}}</span>
          <span class="link">来源：{{newsData.link}}</span>
          <span class="issuser">编辑：{{newsData.issuser}}</span> 
          <span class="watch">浏览量：{{newsData.watch}}</span> 
        </div>
      </div>
      <div class="content-center" v-if="JSON.stringify(newsData) != '{}'"  v-html="newsData.content"></div>
    </div>
    
    <Footer></Footer>
  </div>

</div>
</template>

<script>
// import BScroll from 'better-scroll';
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';
import ShareImpl from '@/Share/Share.js'
export default {
  name: "NewsDetails",
  components: {
    Footer,
    Header
  },
  data() {
    return {
      newsId: '',
      newsData: {}
    }
  },
  beforeCreate() {
    this.$options.newsId = this.$route.params.id;
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("newsId", JSON.stringify(this.$options.newsId))
    })
  },
  destroyed() {
    sessionStorage.removeItem("newsId");
  },
  async created() {
    this.$options.newsId = sessionStorage.getItem("newsId") ? JSON.parse(sessionStorage.getItem("newsId")) : this.$options.newsId;
    const result = await this.$http.newsAndInformation.getNewsInfoByID({
      newsID: this.$options.newsId
    })
    this.getNewsInfoData(result);
   
  },
  mounted() {
    
  },
  methods: {
    

    getNewsInfoData(result) {
      if (result.code === 200) {
        this.newsData = result.data;
        if( this.newsData.classify==1){
          this.$bus.$emit('news', {
                      isNews: true
                  })
        }else if(this.newsData.classify==3){
          this.$bus.$emit('test', {
                      isTest: true
                  })
        }else if(this.newsData.classify==5){
          this.$bus.$emit('review', {
                      isReview: true
                  })
        }
        let  shareImg = result.data.photo;
        let  shareTitle = result.data.name;
        let url = window.location.href;
         if(shareImg){
          shareImg = shareImg;
        }else{
          shareImg='https://jingcaicheshi.com/LOGO.png'
        }
        ShareImpl({
            shareTitle: shareTitle,
            shareDesc: '精彩车市更多精彩，赶快来看看吧。',
            shareUrl: url,
            shareImg: shareImg,
            });
      } else {
        
        return
      }
    },

    initScroll() {
      this.scroll = new BScroll(this.$refs.newsDetContainer, {
        scrollY: true,
        click: true,
        probeType: 3,
        pullUpLoad: {
          threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
          stop: 20
        },
      })

    },
  },
  

}
</script>

<style lang="less">
.news-datails {
  
  height: 100vh;
  width: 100vw;

  .content {
    margin-top: 20px;
    padding: 0 10px;
    font-size: 28px;
    .content-header{
      font-size: 24px;
      h3{
        text-align: center;
        font-weight: 700;
        min-height: 60px;
        max-height:120px;
        color: rgba(64,64,64,1);
        font-size: 32px;
        
      }
      .newsinfo{
        text-align: center;
        margin-bottom: 20px;
      }
    }
    .content-center{
      text-indent: 2em;
      font-size: 28px;
      img {
        width: 100vw;
        // height: 490px;
        // object-fit: cover ;
      }
      .img-footer {
        width: 100%;
        height: 600px;
      }
      p{
        padding: 0;
         overflow: hidden;
        iframe{
          width: 100vw !important;
          margin: 0 auto;
          display: block;
          overflow: hidden;
        }
      }
      
    }
    
    
  }
}
</style>
